import { GreenroomTokenResponse } from '@/types/greenroom/profile.types';
import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const GetGreenroomUserToken = async (): Promise<GreenroomTokenResponse> => {
  return Get({
    host: GREENROOM_HOST,
    url: '/v2/greenroom/auth/profile',
    headers: {
      'Content-Type': 'application/json',
      'bl-global-resource': 'false',
    },
  });
};

export default GetGreenroomUserToken;
